import * as agencyMappings from "@amzn/hvh-connect-cdk-common/dist/lib/agencyHiringConstants/agencyHiringConstantMapping";

const AGENCY_HIRING_CONSTANT_MAPPING_MAP =
  agencyMappings.AGENCY_HIRING_CONSTANT_MAPPING_MAP;

const postfixUrlMap = {
  beta: "-beta-in.devo.jobsatamazon.hvh.a2z.com",
  gamma: "-gamma-in.devo.jobsatamazon.hvh.a2z.com",
  preprod: "-in.preprod.jobsatamazon.hvh.a2z.com",
  prod: ".warehousejobs.in",
};

export const getIAHPrivacyPolicyLink = (settings, agencyName, locale) => {
  if (!settings?.stage || !AGENCY_HIRING_CONSTANT_MAPPING_MAP) {
    return "";
  }

  const { stage } = settings;
  const organizationToDomainMapping = AGENCY_HIRING_CONSTANT_MAPPING_MAP.get(
    stage
  );

  if (
    !organizationToDomainMapping ||
    !(agencyName in organizationToDomainMapping)
  ) {
    return "";
  }

  const stagePrefix = stage.split("-")[0];
  const domain = organizationToDomainMapping[agencyName];
  const baseUrl = `https://${domain}${postfixUrlMap[stagePrefix]}`;

  // For English India (en-IN), don't include locale prefix
  // For all other locales, include the locale prefix
  const localePath = locale && locale !== "en-IN" ? `/${locale}` : "";
  return `${baseUrl}${localePath}/privacy-policy`;
};
